module.exports = __webpack_public_path__ + "media/images/pic/teachers/marin-iwai-b82614374669959ad51be04f34d32cf7.png";